const DANGEROUS_PROTOCOLS = /^(javascript|data|vbscript|blob):/i;

export const isSafeUrl = (url) => {
  if (!url || typeof url !== 'string') return false;
  const trimmed = url.trim();
  if (DANGEROUS_PROTOCOLS.test(trimmed)) return false;
  try {
    const parsed = new URL(trimmed, window.location.origin);
    return ['http:', 'https:', 'mailto:', 'tel:'].includes(parsed.protocol);
  } catch {
    return !trimmed.includes(':') || trimmed.startsWith('/');
  }
};

export const sanitizeUrl = (url) => {
  return isSafeUrl(url) ? url : '#';
};
